module.exports = __webpack_public_path__ + "static/media/temp_w_domu_grzanie_2.8c66f6b5.svg";